<template>
  <div class="contact-us full-screen bg-light">
    <div class="wrapper wrapper-full-page section content">
      <div class="pt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2 text-center">
              <h2 class="text-success"><span class="ti-check-box"></span> Θα λάβετε σε λίγο τον σύνδεσμο επαλήθευσης της ηλεκτρονικής σας διεύθυνσης</h2>
              <h3 class="">Εφόσον υπάρχει στο σύστημά μας το email σας, θα αποστείλουμε εκεί τον σύνδεσμο επαλήθευσης ηλεκτρονικής διεύθυνσης</h3>
              <p class="text-muted mt-4">Μπορείτε να κλείσετε αυτή τη σελίδα</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
